import { Boolean, String, Literal, Record, Union, Partial } from "runtypes";
export const RecordTypesT = Literal("openatts");
export const BlockchainNetworkT = Literal("ethereum");
export const EthereumAddressT = String.withConstraint((maybeAddress) => {
    return /0x[a-fA-F0-9]{40}/.test(maybeAddress) || `${maybeAddress} is not a valid ethereum address`;
});
export var EthereumNetworks;
(function (EthereumNetworks) {
    EthereumNetworks["homestead"] = "1";
    EthereumNetworks["ropsten"] = "3";
    EthereumNetworks["rinkeby"] = "4";
    EthereumNetworks["goerli"] = "5";
    EthereumNetworks["sepolia"] = "11155111";
    EthereumNetworks["polygon"] = "137";
    EthereumNetworks["polygonAmoy"] = "80002";
    EthereumNetworks["local"] = "1337";
})(EthereumNetworks || (EthereumNetworks = {}));
export const EthereumNetworkIdT = Union(Literal(EthereumNetworks.homestead), Literal(EthereumNetworks.ropsten), Literal(EthereumNetworks.rinkeby), Literal(EthereumNetworks.goerli), Literal(EthereumNetworks.sepolia), Literal(EthereumNetworks.polygon), Literal(EthereumNetworks.polygonAmoy), Literal(EthereumNetworks.local));
export const OpenAttestationDNSTextRecordT = Record({
    type: RecordTypesT,
    net: BlockchainNetworkT,
    netId: EthereumNetworkIdT,
    addr: EthereumAddressT,
}).And(Partial({
    dnssec: Boolean,
}));
